import { combineReducers } from 'redux';

import propertyDetail, {initialState as propertyDetailInitialState} from 'ducks/propertyDetail';
import propertyDetailCache, {initialState as propertyDetailCacheInitialState} from 'ducks/propertyDetailCacheSlice';
import userDetails, {initialState as userDetailsInitialState} from 'ducks/userDetails';
import featureFlags, {initialState as featureFlagsInitialState} from 'ducks/featureFlags';
import filters, {initialState as filtersInitialState} from 'ducks/filters';
import reportType, {initialState as reportTypeInitialState} from 'ducks/reportType';
import reportHash, {initialState as reportHashInitialState} from 'ducks/reportHash';
import indicativeSellingPrice, {initialState as indicativeSellingPriceInitialState} from 'ducks/indicativeSellingPrice';
import sellersReservePrice, {initialState as sellersReservePriceInitialState} from 'ducks/sellersReservePrice';
import fewerComparablesReason, {initialState as fewerComparablesReasonInitialState} from 'ducks/fewerComparablesReason';
import settings, {initialState as settingsInitialState} from 'ducks/settings';
import login, {initialState as loginInitialState} from 'ducks/login';
import errorPage, {initialState as errorPageInitialState} from 'ducks/errorPage';
import propertySearch, {initialState as propertySearchInitialState} from 'ducks/propertySearch';
import reportUrl, {initialState as reportUrlInitialState} from 'ducks/reportUrl';
import uploadProgress, {initialState as uploadProgressInitialState} from 'ducks/uploadProgress';
import comparableItem, {getInitialState as getComparableInitialState} from 'ducks/comparableItem';
import reportSections, {initialState as reportSectionsInitialState} from 'ducks/reportSections';
import showNotification, {initialState as showNotificationInitialState} from 'ducks/showNotification';
import theme, {initialState as themeInitialState} from 'ducks/theme';
import coverPageImages, {initialState as coverPageImagesInitialState} from 'ducks/coverPageImages';
import adminPhotos, {initialState as adminPhotosInitialState} from 'ducks/adminPhotos';
import propertyNotes, {initialState as propertyNotesInitialState} from 'ducks/propertyNotes';
import finalise, {initialState as finaliseInitialState} from 'ducks/finalise';
import userSettings, {initialState as userSettingsInitialState} from 'ducks/userSettings';
import testimonials, {initialState as testimonialsInitialState} from 'ducks/testimonials';
import alerts, {initialState as alertsInitialState} from 'ducks/alerts';
import disclaimers, {initialState as disclaimersInitialState} from 'ducks/disclaimers';
import nzTitles, {initialState as nzTitlesInitialState} from 'ducks/nzTitles';

export const rootInitialState = {
  propertyDetail: propertyDetailInitialState,
  propertyDetailCache: propertyDetailCacheInitialState,
  userDetails: userDetailsInitialState,
  disclaimers: disclaimersInitialState,
  featureFlags: featureFlagsInitialState,
  filters: filtersInitialState,
  reportType: reportTypeInitialState,
  reportHash: reportHashInitialState,
  indicativeSellingPrice: indicativeSellingPriceInitialState,
  sellersReservePrice: sellersReservePriceInitialState,
  fewerComparablesReason: fewerComparablesReasonInitialState,
  settings: settingsInitialState,
  login: loginInitialState,
  errorPage: errorPageInitialState,
  propertySearch: propertySearchInitialState,
  reportUrl: reportUrlInitialState,
  uploadProgress: uploadProgressInitialState,
  comparableSales: getComparableInitialState('sales'),
  comparableListings: getComparableInitialState('listings'),
  comparableRentals: getComparableInitialState('rentals'),
  reportSections: reportSectionsInitialState(),
  showNotification: showNotificationInitialState,
  theme: themeInitialState,
  coverPageImages: coverPageImagesInitialState,
  adminPhotos: adminPhotosInitialState,
  propertyNotes: propertyNotesInitialState,
  finalise: finaliseInitialState,
  userSettings: userSettingsInitialState,
  testimonials: testimonialsInitialState,
  nzTitles: nzTitlesInitialState,
  alerts: alertsInitialState,
};

export default combineReducers({
  propertyDetail,
  propertyDetailCache,
  userDetails,
  featureFlags,
  filters,
  reportType,
  reportHash,
  indicativeSellingPrice,
  sellersReservePrice,
  fewerComparablesReason,
  settings,
  login,
  errorPage,
  propertySearch,
  reportUrl,
  comparableSales: comparableItem('sales'),
  comparableListings: comparableItem('listings'),
  comparableRentals: comparableItem('rentals'),
  uploadProgress,
  reportSections,
  showNotification,
  theme,
  coverPageImages,
  adminPhotos,
  propertyNotes,
  userSettings,
  finalise,
  testimonials,
  alerts,
  disclaimers,
  nzTitles,
});